import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=181d6fda&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=181d6fda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181d6fda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('181d6fda')) {
      api.createRecord('181d6fda', component.options)
    } else {
      api.reload('181d6fda', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=181d6fda&scoped=true&", function () {
      api.rerender('181d6fda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Bs51WByZ7SeV/JS/teamMember.vue"
export default component.exports